
import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';
import { ChatGroup } from '@/types/chat';
import { ChatCategory } from '@/types/chatCategories';
import { UnifiedUser } from '@/hooks/useUnifiedUser';
import ChatCategorySelector from './ChatCategorySelector';
import ChatGroupList from './ChatGroupList';

interface ChatSidebarProps {
  chatGroups: ChatGroup[];
  selectedGroup: ChatGroup | null;
  onSelectGroup: (group: ChatGroup) => Promise<void>;
  canCreateGroup: boolean;
  onCreateGroup: () => void;
  onGroupCreated?: () => void;
  isAdmin?: boolean;
  user: UnifiedUser;
}

const ChatSidebar = ({ 
  chatGroups, 
  selectedGroup, 
  onSelectGroup, 
  canCreateGroup, 
  onCreateGroup,
  onGroupCreated,
  isAdmin = false,
  user 
}: ChatSidebarProps) => {
  const [selectedCategory, setSelectedCategory] = useState<ChatCategory | null>(null);

  // Filter groups based on selected category
  const filteredGroups = selectedCategory 
    ? chatGroups.filter(group => {
        const categoryPrefix = `[${selectedCategory.charAt(0).toUpperCase() + selectedCategory.slice(1).replace('-', ' ')}]`;
        return group.chat_name.startsWith(categoryPrefix);
      })
    : chatGroups;

  const handleCreateClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    console.log('Create button clicked in sidebar');
    console.log('Can create group:', canCreateGroup);
    onCreateGroup();
  };

  return (
    <div className="bg-gray-800 border border-gray-700 rounded-lg flex flex-col h-full">
      <div className="p-4 border-b border-gray-700">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-semibold text-white">Chat Groups</h2>
          {canCreateGroup && (
            <Button
              onClick={handleCreateClick}
              size="sm"
              className="bg-sports-green hover:bg-sports-green/90 text-black"
              type="button"
            >
              <Plus className="h-4 w-4 mr-1" />
              New
            </Button>
          )}
        </div>
      </div>

      <ChatCategorySelector
        selectedCategory={selectedCategory}
        onCategorySelect={setSelectedCategory}
        isAdmin={isAdmin}
      />

      <div className="flex-1 overflow-y-auto">
        <ChatGroupList
          chatGroups={filteredGroups}
          selectedGroup={selectedGroup}
          onSelectGroup={onSelectGroup}
          selectedCategory={selectedCategory}
        />
      </div>
    </div>
  );
};

export default ChatSidebar;
